module.exports = __webpack_public_path__ + "img/Group 18备份@2x.61138f01.png";